// theirs
import styled from 'styled-components'
// ours
import { TitleTextAndFeatureImageProps } from '.'
import { respondToRetina, respondToWidth } from '../../../mixins/respondTo'
import { breakpoints, color, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const titleTextAndFeatureImageBaseClass = 'title-text-and-feature-image'

export const StyledTitleTextAndFeatureImage = styled.div<TitleTextAndFeatureImageProps>`
    &.${titleTextAndFeatureImageBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;
        z-index: 2;

        .feature-image {
            background-image: url(${(props) =>
                appendLocationSingle(
                    'images',
                    props.content.contentBackgroundImageSource
                )});
            background-repeat: no-repeat;
            background-size: 50%;
            background-position: 100% 100%;

            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 5;
            animation: animatedBackground 2.8s ease-in-out;
            opacity: 0.3;

            @keyframes animatedBackground {
                from {
                    opacity: 0;
                    background-position-x: 104%;
                }
                to {
                    opacity: 0.3;
                    background-position-x: 100%;
                }
            }

            @media (min-width: ${breakpoints.lg}) {
                opacity: 1;
                background-size: 30%;

                @keyframes animatedBackground {
                    from {
                        opacity: 0;
                        background-position-x: 104%;
                    }
                    to {
                        opacity: 1;
                        background-position-x: 100%;
                    }
                }
            }

            @media (min-width: ${breakpoints.xl}) {
                @keyframes animatedBackground {
                    from {
                        opacity: 0;
                        background-position-x: 104%;
                    }
                    to {
                        opacity: 1;
                        background-position-x: 100%;
                    }
                }
            }

            @media (min-width: ${breakpoints.xxl}) {
                background-size: 25%;
            }

            @media (min-width: ${breakpoints.xxxl}) {
                background-size: 20%;
            }

            &.resistance {
                @media (min-width: ${breakpoints.lg}) {
                    background-size: 27%;
                }
            }

            &.land-rights {
                background-size: 100%;

                @media (min-width: ${breakpoints.lg}) {
                    background-size: 70%;
                }

                @media (min-width: ${breakpoints.xxl}) {
                    background-size: 65%;
                }

                @media (min-width: ${breakpoints.xxxl}) {
                    background-size: 45%;
                }
            }
        }

        @media (min-width: ${breakpoints.lg}) {
            background-size: initial;
        }

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            padding-top: 35%;

            @media (min-width: ${breakpoints.sm}) {
                padding-top: 5%;
            }
        }

        .content-inner {
            margin: 0 auto;
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};
            font-size: ${typography.size.l5};
            color: ${color.deepcarminepink};
            text-transform: uppercase;
            max-width: 785px;
            text-align: center;
            margin-top: -2rem;
            margin-right: auto;
            margin-bottom: 0;
            margin-left: auto;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            ${respondToWidth.xs`
            font-size: ${typography.size.code};
            margin-top: -7rem;
        `}

            ${respondToWidth.xl`
            font-size: ${typography.size.code2};
        `}

        ${respondToRetina.xxxxl`
            font-size: ${typography.size.code3};
        `}
        }

        .text-wrapper {
            margin-bottom: 2.5rem;
            padding: 0;
            margin-top: 0.5rem;
            margin-right: auto;
            margin-bottom: 2rem;
            margin-left: auto;
            max-width: 280px;

            ${respondToWidth.xs`
                margin-top: 2rem;
                max-width: 320px;
            `}

            ${respondToWidth.lg`
                padding: 0 1rem;
            `}

            ${respondToWidth.xxl`
                max-width: 500px;
            `}

            &.makarrata {
                ${respondToWidth.sm`
                    max-width: 415px;
                `}

                ${respondToWidth.xxl`
                    max-width: 500px;
                `}
            }

            p {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextColor};
                padding: 0;

                font-size: ${typography.size.s2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.s3};
                }
            }
        }
    }
`
